<div class="releaseNotesPage">
  <div class="ReleaseNotesContent">
    <div class="stickyHeader">
      <sh-text size="super-header" class="ReleaseNotesHeader">
        {{ 'label.releaseNotes' | translate }}
      </sh-text>
      <div class="searchYearWrapper">
        <div class="searchBarWrapper">
          <sh-search
            id="searchInput"
            label="Search for term"
            (value-changed)="onSearch($event.target.value)"
          ></sh-search>
          <div class="search-navigation" *ngIf="(matchCount$ | async)! > 0">
            <span class="match-count"
              >{{ currentMatch$ | async }}/{{ matchCount$ | async }}</span
            >
            <sh-icon
              icon="arrow-line-up-s"
              (click)="onPreviousMatch()"
            ></sh-icon>
            <sh-icon icon="arrow-line-down-s" (click)="onNextMatch()"></sh-icon>
          </div>
        </div>

        <div class="yearSelection">
          <sh-dropdown id="yearDropdown" label="Year" class="yearDropdown">
            <div *ngFor="let year of yearList$ | async">
              <sh-menu-item
                [label]="year"
                (click)="onYearChange(year)"
                [active]="year === selectedYear"
              ></sh-menu-item>
            </div>
          </sh-dropdown>
        </div>
      </div>
    </div>
    <div class="featuresContent">
      <ng-container *ngIf="featureList$.loading$ | async; else featureDetails">
        <sh-spinner class="image-loader" size="l"></sh-spinner>
      </ng-container>

      <ng-template #featureDetails>
        <div
          class="versionContent"
          *ngFor="
            let version of mergedYearDetails.versions;
            let lastVersion = last
          "
        >
          <div class="versionHeader">
            <sh-text class="versionName" size="header-1"
              >{{ version.releaseVersion }} {{ selectedYear }}</sh-text
            >
            <sh-text size="body-2" class="releaseDate">
              Release Date:
              {{ version.releaseDate | localizedDate }}
            </sh-text>
          </div>

          <div class="featureList" *ngFor="let feature of version.features">
            <div class="feature-item">
              <sh-text
                size="header-2"
                class="featureTitle"
                [innerHTML]="formatFeatureDetails(feature.featureTitle)"
              >
              </sh-text>

              <sh-text
                size="16px"
                class="featureDescription"
                [innerHTML]="formatFeatureDetails(feature.featureDetails)"
              >
              </sh-text>
              <div
                *ngIf="feature.images?.length"
                class="featureImage"
                element-width="100%"
              >
                <img
                  alt="feature slide"
                  src="data:image/jpeg;base64,{{ feature.images[0] }}"
                />
              </div>
            </div>
          </div>
          <sh-divider *ngIf="!lastVersion"></sh-divider>
        </div>
      </ng-template>
    </div>
  </div>
</div>
